import React from "react";

/* Top bar — profile selector, scan button, last-scan timestamp. */

function Topbar({
  profile,
  profiles,
  profilesLoading,
  onSwitchProfile,
  onScanNow,
  onMakeYourOwn,
  isScanning,
  latestScan,
  onNavigate,
  onNewProfile,
  isDemo,
  theme,
  onToggleTheme,
}) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div className="topbar">
      {open && (
        <div
          className="profile-pop-backdrop"
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}
      <div
        ref={ref}
        className={"profile-selector-wrap " + (open ? "is-open" : "")}
      >
        <button className="profile-selector" onClick={() => setOpen((v) => !v)}>
          <div className="profile-mark" style={!profile.faviconUrl ? { background: profile.color } : undefined}>
            {profile.faviconUrl ? (
              <img className="profile-mark-img" src={profile.faviconUrl} alt="" />
            ) : (
              profile.initials
            )}
          </div>
          <div className="profile-name">{profilesLoading ? "loading profiles.." : profile.name}</div>
          <window.I.Chevron size={14} style={{ color: "var(--text-tertiary)" }} />
        </button>

        {open && (
          <div className="profile-pop">
            {profilesLoading ? (
              <div className="item" style={{ color: "var(--text-secondary)" }}>
                <window.I.Refresh size={13} style={{ animation: "spin 900ms linear infinite" }} />
                loading profiles..
              </div>
            ) : profiles.length ? (
              profiles.map((p) => (
                <div
                  key={p.id}
                  className={"item " + (p.id === profile.id ? "is-active" : "")}
                  onClick={() => { onSwitchProfile(p.id); setOpen(false); }}
                >
                  <div className="profile-mark" style={!p.faviconUrl ? { background: p.color, width: 26, height: 26, fontSize: 11.5, borderRadius: 7 } : { width: 26, height: 26, borderRadius: 7 }}>
                    {p.faviconUrl ? (
                      <img className="profile-mark-img" src={p.faviconUrl} alt="" />
                    ) : (
                      p.initials
                    )}
                  </div>
                  <div className="profile-item-body">
                    <div className="profile-item-name">{p.name}</div>
                    <div className="meta">{p.website}</div>
                  </div>
                  {p.id === profile.id && <window.I.Check size={14} style={{ color: "var(--accent)" }} />}
                </div>
              ))
            ) : (
              <div className="item" style={{ color: "var(--text-secondary)" }}>
                <window.I.Briefcase size={13} />
                {isDemo ? "Demo workspace · preview only" : "No business profiles yet"}
              </div>
            )}
            {!isDemo && (
              <>
                <div className="sep" />
                <div
                  className="item add-new"
                  onClick={() => { setOpen(false); onNewProfile(); }}
                >
                  <div style={{
                    width: 26, height: 26, borderRadius: 7,
                    border: "1px dashed var(--border-strong)",
                    display: "grid", placeItems: "center",
                    color: "var(--text-tertiary)",
                  }}>
                    <window.I.Plus size={14} />
                  </div>
                  <div>New business profile</div>
                </div>
              </>
            )}
          </div>
        )}
      </div>

      {(() => {
        const surfaced = Number(latestScan?.surfaced_count || 0);
        if (surfaced <= 0) return null;
        return (
          <button
            type="button"
            className="scan-summary scan-summary-positive scan-summary-mini"
            onClick={() => onNavigate("opportunities")}
            title="View new opportunities"
          >
            <span>
              <strong>{surfaced} new</strong>{" "}
              opportunit{surfaced === 1 ? "y" : "ies"} surfaced in the last scan
            </span>
          </button>
        );
      })()}

      <div className="topbar-spacer" />

      <div className="topbar-actions">
        {onToggleTheme && (
          <button
            className="theme-toggle"
            onClick={onToggleTheme}
            aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
            title={theme === "dark" ? "Light mode" : "Dark mode"}
          >
            {theme === "dark"
              ? <window.I.Sun size={15} />
              : <window.I.Moon size={15} />}
          </button>
        )}
        {!isDemo && (
          <button className="btn btn-ghost btn-sm" onClick={() => onNavigate("scans")}>
            <window.I.Scan size={14} />
            Scan history
          </button>
        )}
        <button
          className="btn btn-primary btn-sm"
          onClick={isDemo ? onMakeYourOwn : onScanNow}
          disabled={isScanning}
        >
          {isScanning ? (
            <>
              <window.I.Sparkles size={14} style={{ animation: "spin 900ms linear infinite" }} />
              Scanning…
            </>
          ) : (
            <>
              {isDemo ? <window.I.ArrowRight size={14} /> : <window.I.Sparkles size={14} />}
              {isDemo ? "Make your own profile" : "Scan now"}
            </>
          )}
        </button>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

window.Topbar = Topbar;
